export const handleInputKey = (callback: () => void) => {
  return (e: Event | KeyboardEvent) => {
    const isKeyboardEvent = 'key' in e

    if (isKeyboardEvent && e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      callback()
    }
  }
}

export const removeEmojisFromString = (text: string) =>
  text
    .split('')
    .filter((ele) => {
      const cpa = ele.codePointAt(0) ?? 0

      return !(cpa > 0xff || cpa === 0x200d || (0xfe00 <= cpa && cpa <= 0xfeff))
    })
    .join('')

export const preventExtraSymbolsFromStringTypeNumber = (
  event: KeyboardEvent
) => {
  ;['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()
}
